module.exports = __webpack_public_path__ + "static/media/Openflo.4a7e3127.png";